import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectAllEntityLocations } from '@user/store/entityLocations'
import { ILeadDetail } from '@user/store/lead'
import { IOpportunityDetail } from '@user/store/opportunity'

export function useContactAlreadyInUse(
  detail: ILeadDetail | IOpportunityDetail,
) {
  const {
    secondaryContactsSummary: { wwmContacts },
  } = detail

  const { billToLocations, serviceLocations } = useSelector(
    selectAllEntityLocations,
  )

  const locations = useMemo(
    () => [...billToLocations, ...serviceLocations],
    [billToLocations, serviceLocations],
  )

  return useCallback(
    (contactId: number) =>
      wwmContacts.some((x) => x.contact.id === contactId) ||
      locations.some((x) => x.contact?.id === contactId),
    [wwmContacts, locations],
  )
}
